'use client'

import Link from 'next/link'
import { SearchIcon, MailIcon, UserIcon } from 'lucide-react'
import type { Footer as FooterType, Header as HeaderType } from '@/payload-types'

import { Logo } from '@/components/payload/Logo/Logo'
import { HeaderNav } from '../Nav'
import { Hamburger } from '../Hamburger.client'
import { type Locale } from '@/providers/Locale/types'
import { cn } from '@/utilities/ui'

interface Props {
    locale: Locale
    header: HeaderType
    footer: FooterType
    showNav: boolean
}

export function StandardHeader({ locale, header, footer, showNav }: Props) {
    return (
        <>
            <div className='py-2 md:py-8 flex justify-between'>
                <div className='flex flex-nowrap items-center'>
                    <Link href='/' className='max-w-[258px]'>
                        <Logo loading='eager' priority='high' />
                    </Link>
                    <div className='ml-4 pl-4 border-l border-slate-300 text-neutral-600 hidden h-full md:flex items-center'>
                        <span>It&apos;s all consuming.</span>
                    </div>
                </div>

                <div className='flex items-center'>
                    {locale === 'en' && (
                        <Link href='/search' className='hidden md:flex gap-2 items-center border-r px-4'>
                            <SearchIcon className='w-5 text-primary' />
                        </Link>
                    )}

                    {locale === 'en' && (
                        <Link href='/newsletter' className='hidden md:flex gap-2 items-center border-r px-4'>
                            <MailIcon className='w-8 h-8 text-white rounded-full p-2 bg-accent' />
                            <span>Subscribe</span>
                        </Link>
                    )}

                    <div className='md:border-l h-full hidden md:flex items-center px-4'>
                        <Link href='/login'>
                            <div className='bg-accent rounded-full w-8 h-8 flex items-center justify-center'>
                                <UserIcon className='w-5 text-white' />
                            </div>
                        </Link>
                    </div>
                    <div className='flex h-full md:border-l px-4'>
                        <Hamburger header={header} footer={footer} />
                    </div>
                </div>
            </div>
            <div className={cn('py-2', { hidden: !showNav })}>
                <HeaderNav header={header} />
            </div>
        </>
    )
}
